import { Component, OnInit } from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';
import { UserService } from '@services/user.service';
import { PageTitleService } from '@services/page-title.service';
import { BatchDetailsService } from '@services/batch-details.service';
import { NotificationsService } from '@services/notifications.service';
@Component({
  selector: 'app-course-select',
  templateUrl: './course-select.component.html',
  styleUrls: ['./course-select.component.scss']
})
export class CourseSelectComponent implements OnInit {
  view: any;
  disableCreate = false;
  constructor(private courseService: CourseService, private pageTitleService:PageTitleService, private userService: UserService, private batchService: BatchDetailsService, private notifications: NotificationsService) { }
  courses = [];
  ngOnInit() {
    this.courseService.get("courses/course_select?mode=read").subscribe(c => {
        if (c != null) {
            this.view = c;
        }
    })
    this.pageTitleService.section ="Course Select"
    this.userService.getRoleDetails().pipe(take(1)).subscribe(user => {
      this.disableCreate = user.prevent_edit || false;
    })
    // this.courseService.get("courses?mode=list").subscribe(c => {
    //     console.log(c)
    //     if (c != null && c.listItems != null) {
    //         this.view = c.listItems;
    //         if (c.push) {
    //         } else {
    //             this.view = [c];
    //         }
    //     }

    // });

  }

  courseListCsv() {
    this.notifications.popNotification("", "Getting CSV");
    this.batchService.getDownloadBatchCsv('includeStatus=failed')
  }
  /*createCourse(): void {
    this.dialogRef = this.dialog.open(WizardComponent, {
      width: '90%',
      //data: this.items_list
    });

    this.dialogRef.afterClosed().subscribe(result => {

    });
  }*/
}
